import { untrack } from "svelte";
import { dispatchSheetEvent } from "../event/event.dispatch";
import {
  SHEET_EVENT_PRESENTATION_END,
  SHEET_EVENT_PRESENTATION_START,
} from "../event/event.consts";
import { stack } from "./global.svelte";
import { findInstance, stackScope } from "./stack.utils";
import { current, type OcSheetV1CurrentState } from "../index.js";

const log = stackScope.scope("events");

/**
 *
 */
export const useStackEvents = (): void => {
  $effect.root(() => {
    $effect(() => {
      if (
        !!stack.current &&
        stack.prev.length === 0 &&
        stack.visited.length === 0 &&
        stack.isPushing
      ) {
        const instance = findInstance(stack.current);
        if (!instance) return log.warn("Presentation start without active instance.");

        dispatchSheetEvent(SHEET_EVENT_PRESENTATION_START, instance, {});
      }

      if (
        !stack.current &&
        stack.prev.length === 0 &&
        stack.visited.length > 0 &&
        !stack.isPopping
      ) {
        stack.visited.splice(0).forEach((visitedId) => {
          const instance = findInstance(visitedId);
          if (!instance) return log.warn("Presentation end without visited instance", visitedId);

          dispatchSheetEvent(SHEET_EVENT_PRESENTATION_END, instance, {});
        });
      }
    });

    $effect(() => {
      const action = untrack(() => stack.action[0]);
      const reason = untrack(() => stack.reason);

      const data: OcSheetV1CurrentState = stack.current
        ? {
            id: stack.current,
            instance: findInstance(stack.current),
            isActive: !!stack.current,
            action,
            reason,
          }
        : { id: null, instance: null, isActive: false, action: null, reason: null };

      current.set(data);
    });
  });
};
